import { useCallback, useEffect } from "react";
import { useAppDispatch, useAppSelector } from "@/lib/store";
import { fetchDashboardData, refreshDashboardStats, clearError, clearData } from "./dashboard.slice";

export const useDashboard = () => {
  const dispatch = useAppDispatch();
  const dashboardState = useAppSelector((state) => state.dashboard);
  const { data, loading, error, lastUpdated } = dashboardState || {
    data: null,
    loading: false,
    error: null,
    lastUpdated: null,
  };

  // Load dashboard data on mount
  useEffect(() => {
    dispatch(fetchDashboardData());
  }, [dispatch]);

  // Auto-refresh every 5 minutes
  useEffect(() => {
    const interval = setInterval(() => {
      dispatch(refreshDashboardStats());
    }, 5 * 60 * 1000); // 5 minutes

    return () => clearInterval(interval);
  }, [dispatch]);

  const refreshData = useCallback(() => {
    dispatch(fetchDashboardData());
  }, [dispatch]);

  const refreshStats = useCallback(() => {
    dispatch(refreshDashboardStats());
  }, [dispatch]);

  const handleClearError = useCallback(() => {
    dispatch(clearError());
  }, [dispatch]);

  const handleClearData = useCallback(() => {
    dispatch(clearData());
  }, [dispatch]);

  return {
    data,
    loading,
    error,
    lastUpdated,
    refreshData,
    refreshStats,
    clearError: handleClearError,
    clearData: handleClearData,
  };
};
